'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _pipe = require('lodash/fp/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _ = require('./');

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/*
function getSingleValueSchema (schema) {
  const { type } = schema
  if (type === 'Array' && Array.isArray(schema.contents)) {
    return schema.contents[0]
  }
  return schema
}

function mapPropsToFormatterSpec (schema) {
  const valueSchema = getSingleValueSchema(schema)
  const { refKeys, type, separator, ...other } = valueSchema
  return {
    ...other,
    type: (type === 'ObjectId') ? 'Object' : type,
    keys: refKeys,
    separator: (separator === undefined) ? '-' : separator,
  }
}
*/

var assign = Object.assign;

var processArrayWithElementSchema = function processArrayWithElementSchema(props) {
  return function (spec) {
    var type = props.type,
        contents = props.contents;

    if (!type || type.toLowerCase() !== 'array' || !contents) return _extends({}, spec, props);

    var _contents$ = contents[0],
        elementType = _contents$.type,
        restElementSchema = _objectWithoutProperties(_contents$, ['type']);

    return assign(spec, _extends({ elementType: elementType }, restElementSchema, props));
  };
};

var tryMapRefKeys = function tryMapRefKeys(spec) {
  if (!spec.refKeys) return spec;

  var refKeys = spec.refKeys,
      other = _objectWithoutProperties(spec, ['refKeys']);

  return _extends({ joinKeys: refKeys }, other);
};

var processObjectId = function processObjectId(spec) {
  var type = spec.type,
      elementType = spec.elementType,
      separator = spec.separator;

  if (type === 'ObjectId') {
    return assign(spec, { type: 'Object', separator: separator || '-' });
  }
  if (type === 'Array' && elementType === 'ObjectId') {
    return assign(spec, { elementType: 'Object', separator: separator || '-' });
  }
  return spec;
};

function mapPropsToFormatterSpec(props) {
  return (0, _pipe2.default)(processArrayWithElementSchema(props), tryMapRefKeys, processObjectId)({});
}

var specKeys = [].concat(_toConsumableArray(_2.default.specKeys), ['refKeys', 'contents']);
function isEqualSpec(a, b) {
  for (var i = 0; i < specKeys.length; i++) {
    if (a[specKeys[i]] !== b[specKeys[i]]) return false;
  }
  return true;
}
mapPropsToFormatterSpec.isEqualSpec = isEqualSpec;
mapPropsToFormatterSpec.specKeys = specKeys;

exports.default = mapPropsToFormatterSpec;


//////////////////
// WEBPACK FOOTER
// ./~/coact/utils/makeFormatter/mapPropsToFormatterSpec.js
// module id = 1684
// module chunks = 0